import { ErrorCharacter } from '@/components/illustrations/ErrorCharacter';
import { ErrorPage } from '@pickleballinc/features/src/error-pages/error-page';
import clsx from 'clsx';
import { ReactNode } from 'react';

interface ErrorPageProps {
	title: string;
	description?: string;
	children?: ReactNode;
	shouldTakeScreenWidth?: boolean;
	isTopBarDisplayed?: boolean;
}

export function TeamLeaguesErrorPage({ title, description, children, shouldTakeScreenWidth = true, isTopBarDisplayed = false }: ErrorPageProps) {
	return (
		<div className="w-full bg-white">
			<div
				className={clsx(`container mx-auto flex flex-col justify-center gap-4`, {
					'w-screen': shouldTakeScreenWidth,
					'w-full': !shouldTakeScreenWidth,
					'h-screen': !isTopBarDisplayed,
					'h-[calc(100vh-56px)] sm:h-[calc(100vh-106px)]': isTopBarDisplayed
				})}
			>
				<ErrorPage
					title={title}
					description={description}
					themeColor="#D97706"
					customErrorCharacter={<ErrorCharacter className="max-w-[200px] md:max-w-[400px] lg:max-w-[500px] h-auto" />}
					titleClassName="mt-10 text-xl font-semibold text-gray-900 sm:text-3xl"
					descriptionClassName="font-medium text-gray-700"
				>
					{children}
				</ErrorPage>
			</div>
		</div>
	);
}
